import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import { View, StyleProp, ViewStyle } from 'react-native';

const EyeIcon = (props: {
    size?: number;
    primaryColor?: string;
    containerStyle?: StyleProp<ViewStyle>;
}) => {
    const size = props.size ?? 15;
    const width = size;
    const height = (size * (16/15));
    return (
        <View style={props.containerStyle}>
        <Svg
            width={width}
            height={height}
            viewBox="0 0 15 16"
            fill="none"
        >
            <Path
                d="M.625 8s2.5-5.333 6.875-5.333S14.375 8 14.375 8s-2.5 5.333-6.875 5.333S.625 8 .625 8z"
                stroke={props.primaryColor ?? '#646464'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M7.5 10c1.036 0 1.875-.896 1.875-2 0-1.105-.84-2-1.875-2-1.036 0-1.875.895-1.875 2 0 1.104.84 2 1.875 2z"
                stroke={props.primaryColor ?? '#646464'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
        </View>
    );
};

export default EyeIcon;
